import React, { useEffect, useState } from 'react'
import { TbArrowsUpDown } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom'
import { IFilters } from 'types/configurations'
import { Pagination } from 'components/Pagination'

import {
  FlexTitle,
  iconUpDown,
  TrHtml,
  TableHtml,
  ThreadHtml,
  TableContainer,
  Tbody,
  Td,
  Th,
  Tr,
  Div
} from 'components/SharedTable/styles'
import { TitleTableUsers } from './models'

export interface ITableProps<T extends { link: string }> {
  titleTable?: TitleTableUsers[]
  tableData: T[]
  selectedFilters?: IFilters
  paginationTotal?: number
  paginationItensByPage?: number
  paginationNumberSelectedPage?: Function
  orderCollumnSelected?: Function
  paginationCurrentPage?: number
}
/**
 * Componente principal para renderizar as tabelas do projeto
 * @param tableData - Array bidimensional estruturado como 1 dimensão os registros e a 2 dimensão os valores
 * @param selectedFilters - Objeto para controle se seleção dos filtros
 * @param titleTable - Array com os objetos que contém o titulo de cada coluna
 * @param paginationTotal - Total de itens mostrados na página
 * @param paginationItensByPage - Numero de itens por página
 * @param paginationNumberSelectedPage - Função que retorna o número da pagina selecionada
 */
export default function SharedTable<T extends { link: string }>({ tableData, selectedFilters, titleTable, paginationTotal, paginationItensByPage, paginationNumberSelectedPage, orderCollumnSelected, paginationCurrentPage }: ITableProps<T>) {
  const navigate = useNavigate()
  const [order, setOrder] = useState<string>('ORDERBY')

  /**
   * Resposavel por definir a ordenação por campo selecionado na coluna da Table
   * Controla também o estado do orderBy
   * @param field
   */
  const handleClickOrderBy = (field: string) => {
    let selectedOrder = null
    if (order === 'ORDERBY') {
      selectedOrder = 'ORDERBYDESC'
    } else {
      selectedOrder = 'ORDERBY'
    }
    setOrder(selectedOrder)
    orderCollumnSelected({ field: field, order: selectedOrder })
  }

  /**
   * Usado para tratar a informação impressa no conteúdo de cada coluna da tabela
   * @param content
   * @param index
   */

  return (
    <>
      <Div data-testid="test-shared-table" className='flex flex-col mb-6'>
        <Div className='overflow-x-auto'>
          <Div className='inline-block min-w-full'>
            <TableContainer>
              <TableHtml>
                <ThreadHtml className='bg-tableTitleBg h-[39px]'>
                  <TrHtml className='divide-x divide-gray-200 h-[39px]'>
                    {titleTable && titleTable?.map((title, index) => (
                      <Th key={index} scope='col'>
                        <FlexTitle>
                          {title.name}
                          {title.sort ? (
                            <div data-testid={`sort-indicator-${title.field}`} onClick={(e: any) => handleClickOrderBy(title.field)}>
                              <TbArrowsUpDown className={iconUpDown} />
                            </div>
                          ) : null}
                        </FlexTitle>
                      </Th>
                    ))}
                  </TrHtml>
                </ThreadHtml>
                <Tbody>
                  {tableData && tableData?.map((data, indexReg) => {
                    return (
                      <Tr key={indexReg} id={`line-${indexReg}`} onClick={() => navigate(data?.link)} >
                        <TableContent<T> content={data} index={indexReg} titleTable={titleTable} />
                      </Tr>
                    )
                  }
                  )}
                </Tbody>
              </TableHtml>
            </TableContainer>
          </Div>
        </Div>
      </Div>

      <Pagination
        paginationTotal={paginationTotal}
        paginationItensByPage={paginationItensByPage}
        paginationNumberSelectedPage={paginationNumberSelectedPage}
        paginationCurrentPage={paginationCurrentPage}
        tableSize={tableData?.length}
      />

    </>
  )
}



export function TableContent<T extends { link: string }>({ content, index, titleTable }: { content: T, index: number, titleTable: TitleTableUsers[] }) {
  const listOfFields = titleTable.map(head => {
    return head.field
  })
  return <>
    {
      listOfFields.map(head => {
        return <Td key={head}>
          {content[head]}
        </Td>
      })
    }
  </>
}
